import { GlobalConfigType } from './global.config.type'
import { SET_GLOBAL_CONFIG } from './types'

export function setGlobalConfig(type: GlobalConfigType, value: any) {
  return { type: SET_GLOBAL_CONFIG, payload: { type, value } }
}
